import { CommonData } from "../../../datastructures/gamestate/gameData";
import { TournamentTexts } from "../../../datastructures/TournamentText";

export class TournamentRegistrationPage {
  //contents for registration page
  private parent: PIXI.Container = new PIXI.Container();
  private parentPrice: PIXI.Container = new PIXI.Container();
  private maxSize: number = 950; //---950 is the size of the parent PIXI.Graphics
  private textBoxSize: Array<number> = [850, 550];
  private bgText: PIXI.Graphics = new PIXI.Graphics()
    .beginFill(0x36586a,.25)
    .drawRoundedRect(10, 0, this.textBoxSize[0], this.textBoxSize[1], 12)
    .endFill();

  private text_RegistrationInfo: PIXI.Text;
  private text_TermAndConditionReminder: PIXI.Text;

  private text_registrationCost_label: PIXI.Text;
  private text_registrationCost_value: PIXI.Text;

  
  private text_RebuyCost_label: PIXI.Text;
  private text_RebuyCost_value: PIXI.Text;


    
  private text_RebuyLeft_label: PIXI.Text;
  private text_RebuyLeft_value: PIXI.Text;
    private tournamentText:TournamentTexts;
    private activeGameData:CommonData;

  //-extras
  private seperator_top:PIXI.Sprite= new PIXI.Sprite(PIXI.Texture.fromFrame('tournament_btn.png'));
  private seperator_bot:PIXI.Sprite= new PIXI.Sprite(PIXI.Texture.fromFrame('tournament_btn.png'));
  constructor(parent: PIXI.Container, styleGold: PIXI.TextStyle,activeGameData:CommonData) {
    this.activeGameData=activeGameData;
    this.tournamentText=this.activeGameData.tournamentText;
    parent.addChild(this.parent);
    //-setup the background
    this.bgText.x = (this.maxSize - this.bgText.width) / 2;
    this.bgText.y = 100;
    // this.bgText.alpha = 0.5;

    //sertupText;
    let mainMsgStyle = new PIXI.TextStyle({
      fontFamily: styleGold.fontFamily,
      fontSize: 30,
      fill: "#ffffff",
      // fontWeight:"bold",
      lineHeight: 40,

      align: "center",
      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 2,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
      wordWrap: true,
      wordWrapWidth: this.textBoxSize[0] - 50,
    });
    let tncStyle = new PIXI.TextStyle({
      fontFamily: styleGold.fontFamily,
      fontSize: 20,
      fill: "#ffffff",
      // fontWeight:"bold",
      lineHeight: 40,

      align: "center",
      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 2,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
      wordWrap: true,
      wordWrapWidth: this.textBoxSize[0] - 50,
    });

    let priceValueStyle = new PIXI.TextStyle({
        fontFamily:styleGold.fontFamily,
        fontSize: 30,
        fill: '#ff9900',
        fontWeight:"bold",
        lineHeight : 50,
    
        align:'center',
        dropShadow: true,
        dropShadowColor: '#000000',
        dropShadowBlur: 2,
        dropShadowAngle: Math.PI / 6,
        dropShadowDistance: 0,
    
      });

    this.text_RegistrationInfo = new PIXI.Text( this.tournamentText.REGISTRATIONINFO,
     mainMsgStyle
    );

    this.text_TermAndConditionReminder = new PIXI.Text(
      this.tournamentText.TERMSANDCONDITIONSAPPLIES,
      tncStyle
    );
    this.text_RegistrationInfo.anchor.set(0.5, 0);
    this.text_RegistrationInfo.x = this.maxSize / 2;
    this.text_RegistrationInfo.y = this.bgText.y + mainMsgStyle.lineHeight / 4;

    this.text_TermAndConditionReminder.anchor.set(0.5, 1);
    this.text_TermAndConditionReminder.x = this.maxSize / 2;
    this.text_TermAndConditionReminder.y = this.bgText.y + this.bgText.height;


    this.text_registrationCost_label=new PIXI.Text(
      this.tournamentText.REGISTERPRICE+": ",
        mainMsgStyle
      );
      this.text_registrationCost_value=new PIXI.Text(
        "€0.00",
        priceValueStyle
      );
      this.text_registrationCost_label.y=this.text_TermAndConditionReminder.y +30;
      this.text_registrationCost_label.x= this.bgText.x;


      this.text_RebuyCost_label=new PIXI.Text(
       this.tournamentText.REBUYPRICE+": ",
        mainMsgStyle
      );
      this.text_RebuyCost_value=new PIXI.Text(
        "0.00",
        priceValueStyle
      );
      this.text_RebuyCost_label.y=this.text_registrationCost_label.y +50;
      this.text_RebuyCost_label.x= this.bgText.x;


      this.text_RebuyLeft_label=new PIXI.Text(
        this.tournamentText.REBUYSLEFT+": ",
        mainMsgStyle
      );
      this.text_RebuyLeft_value=new PIXI.Text(
        "0/0",
        priceValueStyle
      );
      this.text_RebuyLeft_label.y=this.text_registrationCost_label.y +50;
    //   this.text_RebuyLeft_label.x= this.bgText.x+this.bgText.width/2;;


    this.autoUpdatePosition();

        //-extras
        this.seperator_top.anchor.set(.5);
        this.seperator_bot.anchor.set(.5);
        this.seperator_bot.rotation= Math.PI;
        this.seperator_top.scale.y=0.02;
        this.seperator_bot.scale.y= this.seperator_top.scale.y;
        this.seperator_bot.x=this.maxSize/2;
        this.seperator_top.x =this.maxSize/2;
        this.seperator_top.y=100;

        this.seperator_bot.y=this.bgText.y+this.bgText.height;

    // this.bgText.x=900
    this.parent.addChild(this.bgText);
    this.parent.addChild(this.text_RegistrationInfo);
    this.parent.addChild(this.text_TermAndConditionReminder);
    

    this.parent.addChild( this.parentPrice);
    this.parentPrice.addChild(this.text_registrationCost_label);
    this.parentPrice.addChild(this.text_registrationCost_value);

    this.parentPrice.addChild(this.text_RebuyCost_label);
    this.parentPrice.addChild(this.text_RebuyCost_value);

    this.parentPrice.addChild(this.text_RebuyLeft_label);
    this.parentPrice.addChild(this.text_RebuyLeft_value);
    this.parent.addChild(this.seperator_bot);
    this.parent.addChild(this.seperator_top)

  }
  public updateRegistrationFee=(newValue:string):void=>
  {
    this.text_registrationCost_value.text= newValue;
    this.autoUpdatePosition();
  }
  public updateRebuyFee=(newValue:string):void=>
  {
    this.text_RebuyCost_value.text= newValue;
    this.autoUpdatePosition();
  }
  public updateRebuyLeft=(newValue:string):void=>
  {
    this.text_RebuyLeft_value.text= newValue;
    this.autoUpdatePosition();
  }
    private autoUpdatePosition=():void=>
    {
        this.text_registrationCost_value.x=this.text_registrationCost_label.x+this.text_registrationCost_label.width+20;
        this.text_registrationCost_value.y=this.text_registrationCost_label.y;
        
        
        this.text_RebuyCost_value.x=this.text_RebuyCost_label.x+this.text_RebuyCost_label.width+20;
        this.text_RebuyCost_value.y=this.text_RebuyCost_label.y;

        this.text_RebuyLeft_label.x=this.maxSize-this.bgText.x-this.text_RebuyLeft_label.width-this.text_RebuyLeft_value.width-20;
        this.text_RebuyLeft_value.x=this.text_RebuyLeft_label.x+this.text_RebuyLeft_label.width+20;
        this.text_RebuyLeft_value.y=this.text_RebuyLeft_label.y;

       
        
    }
}
